import React from 'react';
import { ReservationsDataOutDTO } from '@api/ringil-api.v2';
import { CalendarFragmentKey, CalendarSurface, FragmentConfig } from '../model';
import { CalendarStateStyle } from '../stateStyle';

export interface FragmentRenderProps {
  data: ReservationsDataOutDTO;
  /** The placement this render came from — carries per-fragment options such as `showIcon`. */
  config: FragmentConfig;
  stateStyle: CalendarStateStyle;
  /** Only the detail popover's workflow-state fragment needs it; the card passes nothing. */
  onStateChange?: () => void;
}

/** `showIcon` defaults to on, so a config written before the option existed keeps its icons. */
export const showIcon = (config: FragmentConfig): boolean => config.showIcon !== false;

export interface CalendarFragmentDefinition {
  key: CalendarFragmentKey;
  labelKey: string;
  labelDefault: string;
  /** Whether the `showIcon` option is meaningful for this fragment. */
  supportsIcon?: boolean;
  /** A surface with no renderer simply cannot host the fragment; the editor hides it there. */
  card?: React.FC<FragmentRenderProps>;
  detail?: React.FC<FragmentRenderProps>;
}

export const supportsSurface = (definition: CalendarFragmentDefinition, surface: CalendarSurface): boolean =>
  surface === 'card' ? !!definition.card : !!definition.detail;
